<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Category & Brand</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <v-select
        v-if="templateHasCategories()"
        :items="getTemplateCategoryValues()"
        v-model="model.category"
        item-text="label"
        item-value="id"
        clearable
        outlined
        dense
        @change="changedModel"
      />
      <v-text-field
        v-else
        v-model="model.category"
        outlined
        dense
        type="text"
        label="Category"
        @keyup="changedModel"
      />

      <v-select
        v-if="templateHasBrands()"
        :items="getTemplateBrandValues()"
        v-model="model.brand"
        item-text="label"
        item-value="id"
        clearable
        outlined
        dense
        @change="changedModel"
      />
      <v-text-field
        v-else
        v-model="model.brand"
        outlined
        dense
        type="text"
        label="Brand"
        @keyup="changedModel"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { isEqual, get } from 'lodash'

export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: {}
    }
  },
  watch: {
    product() {
      this.original = { ...this.product }
      this.model = { ...this.original }
    }
  },
  computed: {
    categories() {
      return get(this.template, 'meta.categories.values', []) || []
    }
  },
  mounted() {
    this.original = { ...this.product }
    this.model = { ...this.original }
  },
  methods: {
    templateHasCategories() {
      return get(this.template, 'meta.categories')
    },
    templateHasBrands() {
      return get(this.template, 'meta.brands')
    },
    getTemplateBrandValues() {
      const valueMap = get(this.template, 'meta.brands.values', {})

      let values = []
      for (const [key, value] of Object.entries(valueMap)){
        values.push({ ...value, id: key })
      }

      // If a parent is defined, only show the ones with the parent of the selected category
      if (this.model.category !== null && this.model.category !== undefined ) {
        values = values.filter(v => !v.parent || v.parent === this.model.category)
      }

      return values
    },
    getTemplateCategoryValues() {
      const valueMap = get(this.template, 'meta.categories.values', {})

      const values = []
      for (const [key, value] of Object.entries(valueMap)){
        values.push({ ...value, id: key })
      }


      return values
    },
    changedModel(val) {
      if (!isEqual(this.original, this.model)) {
        this.$emit('change', { ...this.model })
      }
    }
  }
}
</script>
